export class Observer {

	constructor() {
		this.observers = {};
	}

	connect(action, callback) {
		if (!this.observers[action]) {
			this.observers[action] = [];
		}
		this.observers[action].push(callback);
	}

	async trigger(action, ...args) {
		if (this.observers[action]) {
			const results = [];
			for (var i = 0; i < this.observers[action].length; i++) {
				results.push(await this.observers[action][i](...args));
			}
			return results.length == 1 && typeof results.forceArray == 'undefined' ? results[0] : results;
		} else {
			return args[0] ?? null;
		}
	}

}

export default Observer;
